import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerSharedService } from '../../customer-shared.service';
import { CustomerService } from '../../customer.service';
import { CommonService } from '../../../../shared/services/common.service';
import { UserService } from './user.service';
import { NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../../../shared/services/http.service';
import { countryCodes } from '../../../../shared/services/country_code';
import * as XLSX from 'xlsx';
@UntilDestroy({ checkProperties: true })

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})

export class UsersComponent implements OnInit {
  userList$: any[] = [];
  filteredUserList$: any[] = [];

  quickFilter: 'all' | 'active' | 'inActive' = 'all';
  counts = { total_count: 0, active_count: 0, inactive_count: 0 };

  fileList: File[] = [];
  excelErr: string = '';
  excelErrLink: string = '';
  EXPECTED_HEADERS = ['first_name', 'admin_id', 'last_name', 'email', 'countryCode', 'contact', 'location_ids', 'last_update_user', 'role_id', 'application_id']
  isSuccessMessage: boolean = false;

  isConfirmLoading = false;

  isExcelModalVisible = false;
  isUserModalVisible = false;

  searchText: any;
  searchEnabled = false;
  form!: FormGroup
  customer_id: string;

  isEditMode: boolean = false;
  editData: any = null;

  admin_name = localStorage.getItem('admin_name') || '';
  user_id = localStorage.getItem('user_id') || '';
  admin_email = localStorage.getItem('admin_email') || '';

  listOfColumns: any[] = [
    {
      name: 'ID',
    },
    {
      name: 'FIRST NAME',
    },
    {
      name: 'LAST NAME',
    },
    {
      name: 'EMAIL',
    },
    {
      name: 'CONTACT',
    },
    {
      name: 'ROLE',
    },
    {
      name: 'STATUS',
    },
    {
      name: 'ACTION',
    },
  ]

  userLocations: any[] = [];
  userRoles: any[] = [];
  private allUserRoles: any[] = [];
  defaultUserRoles: any[] = [];
  customerUserRoles: any[] = [];
  private userRolesById = new Map<number, any>();
  private defaultRoleIdByName = new Map<string, number>();
  private roleNamesWithDefaultAndCustomer = new Set<string>();

  isLocationModalVisible: boolean = false;
  selectedLocations: any[] = [];

  isRolesModalVisible: boolean = false;
  selectedRole: number | null = null;
  isLoadingRoles: boolean = false;

  /**
   * Properties to track the current user being modified
   */
  currentUserForLocation: any = null;
  currentUserForRole: any = null;

  isLoadingLocations: boolean = false;
  locationNodes: any[] = [];

  // Add User Form - Additional fields
  countryCodes = countryCodes;
  addFormLocations: any[] = [];
  isLoadingFormLocations: boolean = false;
  applications: any[] = [];
  originalUserData: any = null; // Store original user data for comparison

  constructor(
    public customerSharedService: CustomerSharedService,
    public customerService: CustomerService,
    public userService: UserService,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public commonService: CommonService,
    private ngZone: NgZone,
    private httpService: HttpService,
  ) {

    this.customer_id = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit() {
    this.initializeForm();
    this.getUserRole();
    this.getUsersbyCustomerId();
    this.loadFormLocations();
    this.loadApplications();
  }

  initializeForm() {
    this.form = this.fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
        ]
      ],
      countryCode: ['+91', [Validators.required]],
      contact: [
        null,
        [
          Validators.required,
          Validators.pattern('^[0-9]{10}$')
        ]
      ],
      role: [null, [Validators.required]],
      locationPerms: [[], [this.validateArrayMinLength(1)]],
      applicationId: [[]],
    });
  }

  // Custom validator for array minimum length
  validateArrayMinLength(minLength: number) {
    return (control: any) => {
      if (!control.value || !Array.isArray(control.value) || control.value.length < minLength) {
        return { minLength: { requiredLength: minLength, actualLength: control.value?.length || 0 } };
      }
      return null;
    };
  }

  loadFormLocations() {
    this.isLoadingFormLocations = true;
    this.commonService.getLocationList(Number(this.customer_id)).subscribe({
      next: (response: any) => {
        const locations = Array.isArray(response?.data) ? response.data : [];
        this.addFormLocations = locations.map((location: any) => ({
          label: location.display_name,
          value: location.location_id
        }));
        console.log('Form locations:', this.addFormLocations);
        this.isLoadingFormLocations = false;
      },
      error: (error) => {
        console.error('Error loading locations:', error);
        console.error('Error details:', error?.error || error);
        this.commonService.message.error('Failed to load locations');
        this.isLoadingFormLocations = false;
      }
    });
  }

  loadApplications() {
    const params = {
      filters: JSON.stringify({ customer_id: this.customer_id })
    };
    this.customerService.getApplications(params).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200 && response?.data) {
          // Transform applications to format suitable for multi-select
          this.applications = (response.data || []).map((app: any) => ({
            label: app.name || app.application_name,
            value: app.id || app.application_id,
            icon: app.icon
          }));
        }
      },
      error: (error: any) => {
        console.error('Error fetching applications:', error);
      }
    });
  }

  getUserRole() {
    this.userService.getUserRole(this.customer_id).pipe(untilDestroyed(this)).subscribe((response: any) => {
      this.allUserRoles = (response?.data || []).map((role: any) => ({
        role_id: role.id,
        role_name: role.name,
        privilege: role.privilege,
        customer_id: role.customer_id
      }));
      // Keep ALL roles internally so we can map customer-role assignments correctly.
      this.userRoles = [...this.allUserRoles];
      this.rebuildRoleLookups(this.userRoles);

      // UI rule: if a role name exists in BOTH default and customer, show ONLY the default role in dropdowns.
      this.defaultUserRoles = this.userRoles.filter(r => this.isDefaultRole(r));
      this.customerUserRoles = this.userRoles.filter(r => !this.isDefaultRole(r) && !this.roleNamesWithDefaultAndCustomer.has((r?.role_name ?? '').toString()));
    });
  }

  private isDefaultRole(role: any): boolean {
    const cid = role?.customer_id;
    if (cid == null) return false;
    const n = typeof cid === 'string' ? Number.parseInt(cid, 10) : Number(cid);
    return n === -1;
  }

  private rebuildRoleLookups(roles: any[]): void {
    this.userRolesById = new Map<number, any>();
    this.defaultRoleIdByName = new Map<string, number>();
    this.roleNamesWithDefaultAndCustomer = new Set<string>();

    const hasCustomerByName = new Set<string>();
    for (const role of roles || []) {
      const id = Number(role?.role_id);
      if (Number.isFinite(id)) this.userRolesById.set(id, role);
      const name = (role?.role_name ?? '').toString();
      if (!name) continue;
      if (this.isDefaultRole(role)) {
        if (!this.defaultRoleIdByName.has(name) && Number.isFinite(id)) {
          this.defaultRoleIdByName.set(name, id);
        }
      } else {
        hasCustomerByName.add(name);
      }
    }

    for (const [name] of this.defaultRoleIdByName) {
      if (hasCustomerByName.has(name)) this.roleNamesWithDefaultAndCustomer.add(name);
    }
  }

  private mapRoleIdForDropdown(roleId: any): number | null {
    const id = roleId == null ? NaN : Number(roleId);
    if (!Number.isFinite(id)) return null;
    const role = this.userRolesById.get(id);
    if (!role) return id;

    const name = (role?.role_name ?? '').toString();
    // If user has a customer role whose name duplicates a default role name,
    // the UI only shows the default role, so map to the default role id so patching works.
    if (!this.isDefaultRole(role) && this.roleNamesWithDefaultAndCustomer.has(name)) {
      return this.defaultRoleIdByName.get(name) ?? id;
    }
    return id;
  }
  private normalizeUserDataToForm(userData: any) {
    const rawRole =
      userData?.role_id ??
      userData?.rolesPerms ??
      userData?.rolesPerms?.role_id ??
      (Array.isArray(userData?.rolesPerms) ? userData.rolesPerms?.[0] : undefined);
    const mappedRole = this.mapRoleIdForDropdown(rawRole);
    return {
      firstName: userData.first_name || '',
      lastName: userData.last_name || '',
      email: userData.email || '',
      countryCode: userData.coutryCode || userData.country_code || userData.countryCode || '+91',
      contact: userData.contact || '',
      role: mappedRole,
      locationPerms: userData.locationPerms,
      applicationId: userData.application_id || userData.applicationId || []
    };
  }

  /**
   * Convert form values to API format
   */
  private formValuesToApiFormat(formValues: any) {
    return {
      first_name: formValues.firstName,
      last_name: formValues.lastName,
      email: formValues.email,
      contact: formValues.contact,
      countryCode: formValues.countryCode,
      rolesPerms: formValues.role,
      locationPerms: formValues.locationPerms || [],
      applicationId: formValues.applicationId || []
    };
  }

  editUser(user: any) {
    this.isEditMode = true;
    this.editData = user;
    this.isUserModalVisible = true;
    this.isConfirmLoading = true;

    // Call API to get user details
    this.userService.getUserById(user.user_id).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200 && response?.data) {
          const userData = response.data;
          // Store original data for comparison
          this.originalUserData = this.formValuesToApiFormat(this.normalizeUserDataToForm(userData));
          // Add user_id to original data for comparison
          this.originalUserData.user_id = userData.user_id;

          const formValues = this.normalizeUserDataToForm(userData);
          this.form.patchValue(formValues);
          this.isConfirmLoading = false;
        } else {
          this.commonService.message.error('Failed to load user details');
          this.isConfirmLoading = false;
        }
      },
      error: (error: any) => {
        console.error('Error fetching user details:', error);
        this.commonService.message.error('Failed to load user details');
        // Fallback to using the user data from the list
        const formValues = this.normalizeUserDataToForm(user);
        this.form.patchValue(formValues);
        // Store original data from list as fallback
        this.originalUserData = this.formValuesToApiFormat(formValues);
        this.originalUserData.user_id = user.user_id;
        this.isConfirmLoading = false;
      }
    });
  }

  downloadTemplate() {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([this.EXPECTED_HEADERS]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'User list');
    XLSX.writeFile(wb, 'Add User Template.xlsx');
  }

  toggleUserStatus(user_id: number, is_active: boolean) {
    const updateData = {
      user_id: user_id,
      last_update_user: this.admin_name,
      is_active: is_active
    };

    // Store current filter state
    const currentFilter = this.quickFilter;

    this.userService.updateUser(user_id, updateData).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success('User status updated successfully');
          this.getUsersbyCustomerId();
          // Restore the filter state after refreshing data
          setTimeout(() => {
            this.quickFilter = currentFilter;
            this.filterData();
          }, 100);
        }
      },
      error: (error) => {
        this.commonService.message.error('Failed to update user status');
        console.error('Error updating user status:', error);
      }
    });
  }

  modifyUserLocation(user: any) {
    const obj = {
      user_id: user.user_id,
      customer_id: this.customer_id,
    }

    this.isLocationModalVisible = true;
    this.currentUserForLocation = user;
    this.isLoadingLocations = true;
    this.userLocations = [];

    this.userService.getLocationCheckForUser(obj).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          console.log('User locations response:', response?.result);
          // Transform the API response to the format nz-tree expects
          this.userLocations = this.transformLocationData(response?.result || []);
          // Initialize selectedLocations based on checked items
          this.selectedLocations = this.getCheckedLocationIds(this.userLocations);

          console.log('Tree data with checked state:', this.userLocations);
          console.log('Initial selected locations:', this.selectedLocations);
        } else {
          this.commonService.message.error('Failed to load user locations');
        }
        this.isLoadingLocations = false;
      },
      error: (error) => {
        this.commonService.message.error('Failed to get location check for user');
        console.error('Error getting location check for user:', error);
        this.isLoadingLocations = false;
      }
    });
  }

  modifyUserRoles(user: any) {
    // Show modal and set loading state
    this.isRolesModalVisible = true;
    this.currentUserForRole = user;
    this.isLoadingRoles = true;

    // Set initial selected role from user data
    if (user.role_id) {
      // Convert to number if it's a string
      const raw = typeof user.role_id === 'string' ? parseInt(user.role_id, 10) : user.role_id;
      this.selectedRole = this.mapRoleIdForDropdown(raw);
      console.log('Setting selected role to:', this.selectedRole);
      this.isLoadingRoles = false;
    } else {
      this.selectedRole = null;
      this.isLoadingRoles = false;
    }
  }

  resetUserPassword(user_id: any) {
    const payload = {
      user_id: user_id,
      last_update_user: this.admin_name,
      reset_password: true
    }

    this.userService.updateUser(user_id, payload).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success('Password reset successfully');
        } else {
          this.commonService.message.error(response?.message || 'Failed to reset password');
        }
      },
      error: (error: any) => {
        this.commonService.message.error('An error occurred while resetting password');
        console.error('Error resetting password:', error);
      }
    })
  }

  onSubmit() {
    if (this.form.valid) {
      this.isConfirmLoading = true;

      // Get all form values
      const formValues = this.form.value;
      const locationPerms = formValues.locationPerms || [];
      const applicationId = formValues.applicationId || [];

      if (this.isEditMode) {
        // For edit mode, only send changed fields
        const currentApiFormat: any = this.formValuesToApiFormat(formValues);
        currentApiFormat.user_id = this.editData.user_id;

        // Get only changed fields
        const changedFields = this.commonService.getChangedFields(
          this.originalUserData,
          currentApiFormat,
          [] // No fields to exclude
        );

        // If no changes, show message and return
        if (Object.keys(changedFields).length === 0) {
          this.commonService.message.info('No changes detected');
          this.isConfirmLoading = false;
          return;
        }

        // Send only changed fields directly, without customer_id
        const updatePayload: any = {
          ...changedFields,
          user_id: this.editData.user_id,
          admin_id: this.user_id
        };

        this.userService.updateUser(this.editData.user_id, updatePayload).pipe(untilDestroyed(this)).subscribe({
          next: (response: any) => {
            if (response?.status === 200) {
              this.commonService.message.success('User updated successfully');
              this.isUserModalVisible = false;
              this.resetUserForm();
              this.getUsersbyCustomerId();
            } else {
              this.commonService.message.error(
                response?.message || 'Failed to update user'
              );
            }
            this.isConfirmLoading = false;
          },
          error: (error: any) => {
            this.commonService.message.error('An error occurred while updating the user');
            console.error('Error:', error);
            this.isConfirmLoading = false;
          }
        });
      } else {
        // For add mode, send all required fields
        const userData: any = {
          first_name: formValues.firstName,
          last_name: formValues.lastName,
          email: formValues.email,
          contact: formValues.contact,
          countryCode: formValues.countryCode,
          rolesPerms: formValues.role,
          locationPerms: locationPerms,
          applicationId: applicationId.length > 0 ? applicationId : undefined,
          admin_id: this.user_id,
          customer_id: this.customer_id
        };
        const formData: any = {
          userData: [userData],
        };

        this.userService.addUser(formData).pipe(untilDestroyed(this)).subscribe({
          next: (response: any) => {
            if (response?.status === 200) {
              this.commonService.message.success('User added successfully');
              this.isUserModalVisible = false;
              this.resetUserForm();
              this.getUsersbyCustomerId();
            } else {
              this.commonService.message.error(
                response?.message || 'Failed to add user'
              );
            }
            this.isConfirmLoading = false;
          },
          error: (error: any) => {
            this.commonService.message.error('An error occurred while adding the user');
            console.error('Error:', error);
            this.isConfirmLoading = false;
          }
        });
      }
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.values(this.form.controls).forEach(control => {
        control.markAsTouched();
      });
    }
  }

  resetUserForm() {
    this.form.reset({
      countryCode: '+91',
      locationPerms: [],
      applicationId: [],
      documents: [],
      docField: null
    });
    this.isEditMode = false;
    this.editData = null;
    this.originalUserData = null;
  }

  getUsersbyCustomerId() {
    this.counts = { total_count: 0, active_count: 0, inactive_count: 0 };
    this.ngZone.runOutsideAngular(() => {
      this.isConfirmLoading = true;
      this.userService.getUsersbyCustomerId(this.customer_id).pipe(untilDestroyed(this)).subscribe(response => {
        if (response?.status === 200 && response?.data) {
          this.userList$ = response?.data;

          this.userList$.forEach((user) => {
            this.counts.total_count++;
            if (user?.is_active === true) this.counts.active_count++;
            if (user?.is_active === false) this.counts.inactive_count++;
          });
          this.getSearchDetails('');
          this.ngZone.run(() => {
            this.isConfirmLoading = false;
          });
        } else {
          this.ngZone.run(() => {
            this.isConfirmLoading = false;
          });
        }
      });
    })
  }

  getSearchDetails(val: string) {
    this.searchText = val.trim().toLowerCase();
    this.filteredUserList$ = this.userList$.filter(user => {
      return (user.first_name && user.first_name.toLowerCase().includes(this.searchText)) ||
        (user.last_name && user.last_name.toLowerCase().includes(this.searchText)) ||
        (user.email && user.email.toLowerCase().includes(this.searchText)) ||
        (user.contact && user.contact.toString().includes(this.searchText));
    });
  }

  onFileChange(event: any): void {
    const file = event.target.files;
    const newFiles = Array.from(file);
    for (const file of newFiles as File[]) {
      const fileName = file.name.toLowerCase();
      const validExtensions = ['.xlsx', '.xls', '.csv'];
      const isValidType = validExtensions.some((ext) => fileName.endsWith(ext));
      if (!isValidType) {
        this.commonService.message.error(`File ${file.name} is not an allowed file type. Please upload excel file only.`);
        continue;
      }
      this.fileList.push(file);
    }
  }

  removeFile(index: number): void {
    this.fileList.splice(index, 1);
  }

  validateExcelFile(): boolean {
    if (this.fileList.length === 0) {
      this.commonService.message.error('Please select a file to upload');
      return false;
    }
    return true;
  }

  prepareExcelFormData(): FormData {
    const formData = new FormData();
    formData.append('file', this.fileList[0], this.fileList[0].name);
    formData.append('customer_id', this.customer_id);
    formData.append('admin_name', this.admin_name);
    formData.append('admin_id', this.user_id);
    formData.append('admin_email', this.admin_email);
    return formData;
  }

  onExcelSubmit() {
    // Validate file selection
    if (!this.validateExcelFile()) {
      return;
    }
    this.resetExcelState();
    this.isConfirmLoading = true;
    // Prepare and submit the form data
    const formData = this.prepareExcelFormData();

    this.userService.addUserExcel(formData).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        this.handleExcelUploadResponse(response);
        this.isConfirmLoading = false;
      },
      error: (error: any) => {
        this.handleExcelUploadError(error);
        this.isConfirmLoading = false;
      }
    });
  }

  resetExcelState(): void {
    this.excelErr = '';
    this.excelErrLink = '';
    this.isSuccessMessage = false;
  }

  handleExcelUploadResponse(response: any): void {
    if (response?.status === 200) {
      const resultUrl = response?.data?.result || response?.result;

      if (resultUrl) {
        this.excelErrLink = resultUrl;
        // Automatically download the result file
        this.downloadFile(resultUrl);
      }

      // Set success message
      this.isSuccessMessage = true;
      this.excelErr = 'Excel file processed successfully';

      // Only close the modal if there are no errors or warnings
      if (!this.excelErrLink) {
        this.isExcelModalVisible = false;
        this.fileList = []; // Clear the file list
      }
      this.getUsersbyCustomerId() // Refresh the user list
    } else {
      // Handle error responses
      this.isSuccessMessage = false;
      this.excelErr = response?.message || response?.error_message || 'Failed to process excel file';
      if (response?.log_file_url) {
        this.excelErrLink = response.log_file_url;
      }
      this.commonService.message.error(this.excelErr);
    }
  }

  handleExcelUploadError(error: any): void {
    this.isSuccessMessage = false;
    this.excelErr = error?.error?.message || 'An error occurred while uploading the excel file';
    if (error?.error?.log_file_url) {
      this.excelErrLink = error.error.log_file_url;
    }
    this.commonService.message.error(this.excelErr);
    console.error('Error uploading excel:', error);
  }

  downloadLogFile() {
    if (this.excelErrLink) {
      this.downloadFile(this.excelErrLink);
    }
  }

  downloadFile(url: string) {
    if (!url) return;

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = url.split('/').pop() || 'userReport.xlsx'; // Extract filename from URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  filterData(): void {
    if (this.quickFilter === 'all') {
      this.filteredUserList$ = this.userList$;
    } else if (this.quickFilter === 'active') {
      this.filteredUserList$ = this.userList$.filter(
        (user) => user.is_active
      );
    } else if (this.quickFilter === 'inActive') {
      this.filteredUserList$ = this.userList$.filter(
        (user) => !user.is_active
      );
    }
  }

  refreshHandler() {
    this.quickFilter = 'all';
    this.userList$ = [];
    this.searchText = '';
    this.searchEnabled = false;
    this.filteredUserList$ = [];
    this.getUsersbyCustomerId();
  }

  showModal(type: string): void {
    if (type === 'excel') {
      this.isExcelModalVisible = true;
    } else if (type === 'user') {
      this.isUserModalVisible = true;
      this.isEditMode = false;
      this.editData = null;
      this.resetUserForm();
    }
  }

  handleCancel(type: string): void {
    if (type === 'excel') {
      this.isExcelModalVisible = false;
    } else if (type === 'user') {
      this.isUserModalVisible = false;
      this.resetUserForm();
    }
  }

  /**
   * Transform location data to format expected by nz-tree
   */
  transformLocationData(locations: any[]): any[] {
    return locations.map(location => ({
      title: location.location_name || location.display_name,
      key: location.location_id.toString(),
      checked: !!location.checked, // Use the checked property from API
      expanded: true,
      icon: 'folder',
      isLeaf: !location.children || location.children.length === 0,
      children: location.children ? this.transformLocationData(location.children) : []
    }));
  }

  /**
   * Get IDs of locations that are checked
   */
  getCheckedLocationIds(locations: any[]): string[] {
    const checkedIds: string[] = [];
    console.log('Getting checked IDs from locations:', locations);

    const extractCheckedIds = (items: any[]) => {
      items.forEach(item => {
        // Log the structure of each item to debug
        console.log('Processing item:', item.title, 'checked:', item.checked, 'key:', item.key);

        if (item.checked) {
          const keyToAdd = item.key?.toString();
          if (keyToAdd) {
            checkedIds.push(keyToAdd);
            console.log('Adding checked item key:', keyToAdd);
          }
        }
        if (item.children && item.children.length > 0) {
          extractCheckedIds(item.children);
        }
      });
    };

    extractCheckedIds(locations);
    console.log('Returning checkedIds:', checkedIds);
    return checkedIds;
  }

  /**
   * Handle location selection change
   */
  onLocationSelectionChange(event: any): void {
    console.log('Selection change event:', event);

    let checkedKeys = event;

    // If event is an object with a checkedKeys property
    if (event && typeof event === 'object' && event.checkedKeys) {
      checkedKeys = event.checkedKeys;
    }

    // Handle the different possible formats
    if (Array.isArray(checkedKeys)) {
      // For _NzTreeNode objects
      if (checkedKeys.length > 0 && typeof checkedKeys[0] === 'object') {
        this.selectedLocations = checkedKeys.map((node: any) => {
          // Extract key from node object
          if (node._key) return node._key;
          if (node.key) return node.key;
          return node;
        });
      } else {
        // Already simple values
        this.selectedLocations = [...checkedKeys];
      }
    } else {
      console.warn('Unexpected format for checkedKeys:', checkedKeys);
      // Keep the previous selection if format is unexpected
    }

    console.log('Updated selected locations:', this.selectedLocations);
  }

  /**
   * Save user location access changes
   */
  saveUserLocations(): void {
    if (!this.currentUserForLocation) {
      this.commonService.message.error('User information is missing');
      return;
    }

    this.isConfirmLoading = true;

    // Convert string IDs to numbers for the API
    const locationIds = this.selectedLocations.map(id =>
      typeof id === 'string' ? parseInt(id, 10) : id
    );

    // Create payload with the expected structure - using group_id as the selected locations
    const payload = {
      user_id: this.currentUserForLocation.user_id,
      customer_id: this.customer_id,
      first_name: this.currentUserForLocation.first_name,
      last_name: this.currentUserForLocation.last_name,
      email: this.currentUserForLocation.email,
      contact: this.currentUserForLocation.contact,
      last_update_user: this.admin_name,
      group_id: locationIds // Ensure this is sent as an array
    };

    console.log('Sending location access update:', payload);

    // Use updateUser instead of updateUserLocations since they point to the same endpoint
    this.userService.updateUserStatus(payload).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success('User location access updated successfully');
          this.getUsersbyCustomerId();
        } else {
          this.commonService.message.error(response?.message || 'Failed to update user location access');
        }
        this.isLocationModalVisible = false;
        this.isConfirmLoading = false;
      },
      error: (error: any) => {
        this.commonService.message.error('An error occurred while updating user location access');
        console.error('Error updating user location access:', error);
        this.isLocationModalVisible = false;
        this.isConfirmLoading = false;
      }
    });
  }

  handleRolesCancel(): void {
    this.isRolesModalVisible = false;
    this.currentUserForRole = null;
    this.selectedRole = null;
  }

  saveUserRoles(): void {

    if (this.selectedRole === null || this.selectedRole === undefined) {
      this.commonService.message.error('Please select a role for this user');
      return;
    }
    this.isConfirmLoading = true;

    // Create payload for role update
    const payload = {
      user_id: this.currentUserForRole.user_id,
      last_update_user: this.admin_name,
      role_id: this.selectedRole
    };

    console.log('Updating user role with payload:', payload);

    this.userService.addUserRole(payload).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success('User role updated successfully');
          this.getUsersbyCustomerId();
        } else {
          this.commonService.message.error(response?.message || 'Failed to update user role');
        }
        this.isRolesModalVisible = false;
        this.isConfirmLoading = false;
      },
      error: (error: any) => {
        this.commonService.message.error('An error occurred while updating user role');
        console.error('Error updating user role:', error);
        this.isRolesModalVisible = false;
        this.isConfirmLoading = false;
      }
    });
  }

  handleLocationCancel(): void {
    this.isLocationModalVisible = false;
    this.currentUserForLocation = null;
    this.selectedLocations = [];
    this.userLocations = [];
  }

  /**
   * Handle node click to toggle selection
   */
  handleNodeClick(event: any): void {
    console.log('Node clicked:', event);

    // Toggle the checkbox when the node is clicked
    const node = event.node;
    if (node) {
      // Get the key (support both _key and key property formats)
      const key = node._key || node.key;

      if (!key) {
        console.error('Unable to determine key for node:', node);
        return;
      }

      // Check if this key is currently in the selected locations
      const isCurrentlyChecked = this.selectedLocations.includes(key);

      if (isCurrentlyChecked) {
        // Remove from selected if it's already checked
        this.selectedLocations = this.selectedLocations.filter(id => id !== key);
      } else {
        // Add to selected if it's not checked
        this.selectedLocations = [...this.selectedLocations, key];
      }

      console.log('Updated selected locations after node click:', this.selectedLocations);
    }
  }
}